<template>
    <div class="storeData">
        <div class="storeData_nap">
            <div class="storeData_napL">统计时间：{{nowDate}}</div>
            <div class="storeData_napR">
                <el-radio-group class="hide_input" v-model="tabPosition">
                    <el-radio-button 
                        :label="items.type"
                        v-for="(items, index) in napList"
                        :key="index"
                        @click.native.prevent="selectTimeType(items.type)"
                    >
                        {{ items.name }}
                        <!-- 月 -->
                        <el-date-picker
                            v-show="items.type == 'month'"
                            class="date"
                            @change="dateChangeMonth"
                            v-model="dateDay"
                            type="month"
                            value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                        <!-- 自定义 -->
                        <el-date-picker
                            v-show="items.type == 'day'"
                            class="date"
                            @change="dateRangeChange"
                            v-model="dateDay"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                    </el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <div class="storeData_pane_trad_nap" style="padding-bottom:0px">
            <div class="trad_nap">
                <p class="trad_nap_name">企业认证</p>
                <div class="trad_nap_num">
                    <p class="trad_nap_money">{{enterPriseIdentityCount}}</p>
                </div>
            </div>
            <div class="trad_nap">
                <p class="trad_nap_name">服务商入驻</p>
                <div class="trad_nap_num">
                    <p class="trad_nap_money">{{providerPassCount}}</p>
                </div>
            </div>
            <div class="trad_nap">
                <p class="trad_nap_name">材料数</p>
                <div class="trad_nap_num">
                    <p class="trad_nap_money">{{printCount}}</p>
                </div>
            </div>
            <div class="trad_nap">
                <p class="trad_nap_name">服务数</p>
                <div class="trad_nap_num">
                    <p class="trad_nap_money">{{serviceCount}}</p>
                </div>
            </div>
            <div class="trad_nap">
                <p class="trad_nap_name">商家入驻</p>
                <div class="trad_nap_num">
                    <p class="trad_nap_money">{{shopCount}}</p>
                </div>
            </div>
        </div>
        <div class="storeData_pane_trad_nap" style="padding-bottom: 0px;">
            <div class="trad_nap">
                <p class="trad_nap_name">商品数</p>
                <div class="trad_nap_num">
                    <p class="trad_nap_money">{{goodsCount}}</p>
                </div>
            </div>
            <div class="trad_nap">
                <p class="trad_nap_name">个人认证</p>
                <div class="trad_nap_num">
                    <p class="trad_nap_money">{{personIdentityCount}}</p>
                </div>
            </div>
            <div class="trad_nap">
                <p class="trad_nap_name">设计师入驻</p>
                <div class="trad_nap_num">
                    <p class="trad_nap_money">{{designerCount}}</p>
                </div>
            </div>
            <div class="trad_nap">
                <p class="trad_nap_name">模型数</p>
                <div class="trad_nap_num">
                    <p class="trad_nap_money">{{modelCount}}</p>
                </div>
            </div>
        </div>
        <div class="storeData_pane_trad_nap">
            <div
                class="trad_nap"
                v-for="(items, index) in shopFirstList"
                :key="index"
            >
                <p class="trad_nap_name">{{ items.name }}</p>
                <div class="trad_nap_num">
                    <p class="trad_nap_money">{{ items.goodsCount }}</p>
                </div>
            </div>
        </div>
        <div class="storeData_pane">
            <div class="orderSearchBox">
                <el-input v-model="name" placeholder="名称"></el-input>
                <el-button class="searchBtn" @click="searchInfo">搜索</el-button>
                <el-button type="text" class="resetBtn" @click="resetData">
                    <i class="iconfont icon-qingchushujuku"></i>
                    <span>清除条件</span>
                </el-button>
            </div>
            <el-tabs tab-position="top" type="card" @tab-click="handleClick">
                <el-tab-pane label="商品">
                    <goods-info ref="goodsInfoRef"></goods-info>
                </el-tab-pane>
                <el-tab-pane label="服务">
                    <service-info ref="serviceRef"></service-info>
                </el-tab-pane>
                <el-tab-pane label="模型">
                    <design-model-info ref="designModelRef"></design-model-info>
                </el-tab-pane>
                <el-tab-pane label="材料">
                    <material-manager-info ref="materialManagerRef"></material-manager-info>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import { findDesignerInfo,modelNumber,getShopProvidersCount,
        findEnterPriseIdentityCount, findPersonalIdentityCount } from '../../utils/interface';
    import goodsInfo from './goodsInfo'
    import serviceInfo from './serviceInfo'
    import materialManagerInfo from './materialManagerInfo'
    import designModelInfo from './designModelInfo'
    export default {
        name: "designerRangliste",
        components: {
            // 商品信息
            goodsInfo,
            serviceInfo,
            materialManagerInfo,
            designModelInfo
        },
        computed: {
            contentViewHeight() {
                let height = document.documentElement.clientHeight - 120;
                return {minHeight: height + 'px'}
            },
        },
        data() {
            return {
                name:"",
                nowDate:"",
                enterPriseIdentityCount:0,
                personIdentityCount:0,
                providerPassCount:0,
                shopCount:0,
                designerCount:0,
                goodsCount:0,
                serviceCount:0,
                printCount:0,
                modelCount:0,
                shopFirstList:[],
                payListIndex: "0",
                startDate:"",
                endDate:"",
                createDateValue:null,
                dateDay:null,
                loading: false,
                tabPosition: "nowDay",
                napList: [
                    {
                        type: "month",
                        name: "月",
                    },
                    {
                        type: "day",
                        name: "日区间",
                    },
                ],
                tabIndex:0,
            }
        },
        created(){
            let templateDate = new Date();
            this.endDate = this.timeDate(new Date());
            console.log(this.endDate);
            templateDate.setDate(templateDate.getDate() - 30); // 今天的前N天的日期，N自定义
            this.startDate = templateDate.getFullYear() + '-' + (templateDate.getMonth() + 1) + '-' + templateDate.getDate();
            console.log(this.startDate);
            this.nowDate = this.startDate +"——"+ this.endDate;
        },
        mounted(){
            this.getList();
        },
        /*mounted(){
            this.getDataList(0);
        },*/
        methods: {
            selectTimeType(type) {
                this.tabPosition = type;
            },
            getList(){
                this.getModelNumber();
                this.findEnterPriseIdentityCount();
                this.findPersonalIdentityCount();
                this.getShopProvidersCount();
                this.getDataList(this.tabIndex);
            },
            handleClick(tab){
                this.name = "";
                this.tabIndex = tab.index;
                this.getDataList(tab.index);
            },
            getDataList(index){
                if(index==0){
                    this.$refs.goodsInfoRef.init(this.startDate,this.endDate,this.name);
                }else if(index==1){
                    this.$refs.serviceRef.init(this.startDate,this.endDate,this.name);
                }else if(index==2){
                    this.$refs.designModelRef.init(this.startDate,this.endDate,this.name);
                }else if(index==3){
                    this.$refs.materialManagerRef.init(this.startDate,this.endDate,this.name);
                }
            },
            getModelNumber(){
                let params = {
                    startDate:this.startDate,
                    endDate:this.endDate
                };
                modelNumber(params).then((res)=>{
                    if(res.success){
                        this.modelCount = res.data.modelCount;
                        this.designerCount = res.data.designerCount;
                    }
                });
            },
            findEnterPriseIdentityCount(){
                let params = {
                    startDate:this.startDate,
                    endDate:this.endDate
                };
                findEnterPriseIdentityCount(params).then((res)=>{
                    if(res.success){
                        this.enterPriseIdentityCount = res.data;
                    }
                });
            },
            findPersonalIdentityCount(){
                let params = {
                    startDate:this.startDate,
                    endDate:this.endDate
                };
                findPersonalIdentityCount(params).then((res)=>{
                    if(res.success){
                        this.personIdentityCount = res.data;
                    }
                });
            },
            getShopProvidersCount(){
                let params = {
                    startDate:this.startDate,
                    endDate:this.endDate
                };
                getShopProvidersCount(params).then((res)=>{
                    if(res.success){
                        this.providerPassCount = res.data.providersCount;
                        this.serviceCount = res.data.serviceCount;
                        this.printCount = res.data.printCount;
                        this.shopCount = res.data.shopCount;
                        this.goodsCount = res.data.goodsCount;
                        this.shopFirstList = res.data.categoryList;
                    }
                });
            },
            searchInfo(){
                this.getDataList(this.tabIndex);
            },
            resetData(){
                this.name = "";
                this.searchInfo();
            },
            dateChangeMonth(date) {
                this.startDate = this.getCurrentMonthFirst(date);
                this.endDate = this.getCurrentMonthLast(date);
                this.nowDate = this.startDate +"——"+ this.endDate;
                this.getList();
            },
            getCurrentMonthFirst(data){
                let date = new Date(data);
                date.setDate(1);
                let month = parseInt(date.getMonth()+1);
                let day = date.getDate();
                if (month < 10) {
                    month = '0' + month
                }
                if (day < 10) {
                    day = '0' + day
                }
                return date.getFullYear() + '-' + month + '-' + day;
            },
            getCurrentMonthLast(data){
                let date=new Date(data);
                let currentMonth=date.getMonth();
                let nextMonth=++currentMonth;
                let nextMonthFirstDay=new Date(date.getFullYear(),nextMonth,1);
                let oneDay=1000*60*60*24;
                let lastTime = new Date(nextMonthFirstDay-oneDay);
                let month = parseInt(lastTime.getMonth()+1);
                let day = lastTime.getDate();
                if (month < 10) {
                    month = '0' + month
                }
                if (day < 10) {
                    day = '0' + day
                }
                return date.getFullYear() + '-' + month + '-' + day;
            },
            dateRangeChange(date) {
                this.startDate = date[0];
                this.endDate = date[1];
                this.nowDate = this.startDate +"——"+ this.endDate;
                this.getList();
            },
            timeDate(value){
                let date = new Date(value);
                let y = date.getFullYear();
                let MM = date.getMonth() + 1;
                MM = MM < 10 ? "0" + MM : MM;
                let d = date.getDate();
                d = d < 10 ? "0" + d : d;
                return y + "-" + MM + "-" + d;
            },
        }
    }

</script>

<style scoped lang="less">
.date{
    width: 100px;
}
.storeData {
    background-color: #ffffff;
    padding: 20px;
    margin: 0 20px;

    .storeData_nap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
    }
}

//隐藏的CSS代码
/*按钮日期选择器隐藏ipnut*/
.hide_input {
    position: relative !important;
}

//修改控件自带的css
.hide_input /deep/ .el-date-editor {
    position: absolute; //绝对定位
    top: 0;
    left: 0;
    opacity: 0; //设置完全透明
}

.hide_input /deep/ .el-input__prefix {
    left: 0;
    width: 55px;
}

.storeData_pane_trad_nap {
    display: flex;
    align-items: center;
    padding: 20px;

    .trad_nap2 {
        background: rgba(147, 185, 255, 0.158);
        border-bottom: 4px solid rgb(88, 146, 253);
    }

    .trad_nap {
        padding: 0 40px;
        font-size: 14px;
        width: 25%;
        background: rgba(185, 210, 255, 0.3);
        text-align: center;
        margin-right: 10px;
        .trad_nap_name {
            margin-bottom: 4px;
        }

        .trad_nap_num {
            display: flex;
            align-items: center;
            justify-content: center;

            .trad_nap_money {
                font-weight: bold;
            }

            .trad_nap_mess {
                color: #666;
            }

            .trad_nap_pre {
                display: flex;
                align-items: center;
                color: red;
            }
        }
    }
}
.storeData_pane {
    position: relative;
    .orderSearchBox {
        position: absolute;
        right: 0;
        display: flex;
        margin-bottom: 20px;
        z-index: 999;
        .searchTop{
            display: flex;
            align-items: center;
            margin-bottom: 22px;
        }
        .searchBottom{
            display: flex;
            align-items: center;
            margin-bottom: 22px;
        }
        .searchItem{
            display: flex;
            align-items: center;
            margin-right: 30px;
            .name{
                padding-right: 20px;
                min-width: 100px;
            }
        }
        /deep/ .el-input {
            width: initial;
        }
        /deep/ .el-input__inner {
            width: 242px;
            height: 35px;
            min-height: 35px;
            font-size: 12px;
            color: #999999;
            background-color: #f2f4f7;
            border: 1px solid #f2f4f7;
            border-radius: 5px;
            margin-right: 20px;

            &:hover, &:focus {
                background-color: #fff;
                border: 1px solid #108EE9;
            }
        }
        /deep/.el-range-editor{
            width: 500px;
            /deep/.el-range-input{
                width: 242px;
                height: 32px;
                min-height: 32px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
            }
            /deep/.el-range__icon,/deep/.el-range-separator,/deep/.el-range__close-icon{
                line-height: 29px;
            }
            &:hover, &:focus {
                background-color: #fff;
                border: 1px solid #108EE9;
                /deep/.el-range-input{
                    background-color: #fff;
                }
            }
        }
        /deep/ .el-input__prefix {
            top: -3px;
        }
        /deep/ .el-input__suffix {
            top: 2px;
        }
        /deep/ .el-button {
            display: block;
            line-height: 35px;
            padding: 0;
            height: 35px;
        }
        .searchBtn {
            width: 82px;
            background: #3d7fff;
            border: none;
            border-radius: 15px;
            font-size: 14px;
            color: #FFFFFF;
        }
        .resetBtn {
            color: #333333;
            &:hover{
                color: #3d7fff;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/statistic/dataAnalyse.vue